import React from 'react';
import Prism from 'prismjs';
import 'prismjs/themes/prism.css';

const QuestionItem = ({ question }) => {
    React.useEffect(() => {
        Prism.highlightAll();
    }, [question]);

    return (
        <div className="question-item">
            <h3>{question.q}</h3>
            <p>{question.a}</p>
            {question.code && (
                <pre>
                    <code className="language-javascript">{question.code}</code>
                </pre>
            )}
        </div>
    );
};

export default QuestionItem;
